import React from 'react';
import useTranslation from '../../hooks/useTranslation';

/**
 * Always-visible key for the marker colours + shape cues. Uses simple solid
 * swatches (not the two-tint scoop) so at legend size they read as one clear
 * status dot instead of "two stacked balls".
 */
const CLOCK = <><circle cx="12" cy="12" r="5.5" fill="none" stroke="#fff" strokeWidth="1.6" /><path d="M12 8.5V12l2.2 1.3" stroke="#fff" strokeWidth="1.6" fill="none" strokeLinecap="round" /></>;

const SWATCHES = {
    green: { color: '#55A86A', glyph: null },
    red: {
        color: '#F4303C',
        glyph: <><rect x="8" y="7" width="2.5" height="10" rx="1.25" fill="#fff" /><rect x="13.5" y="7" width="2.5" height="10" rx="1.25" fill="#fff" /></>,
    },
    tan: { color: '#C79A63', glyph: CLOCK },
    scheduled: { color: '#8C7359', glyph: CLOCK },
};

function LegendSwatch({ variant }) {
    const s = SWATCHES[variant] || SWATCHES.red;
    return (
        <span className="legend-swatch" style={{ background: s.color }} aria-hidden="true">
            {s.glyph && (
                <svg viewBox="0 0 24 24" width="14" height="14">{s.glyph}</svg>
            )}
        </span>
    );
}

function MapLegend({ inline = false }) {
    const { t } = useTranslation();
    const items = [
        { variant: 'green', label: t('tracker.legend.available', 'Beschikbaar') },
        { variant: 'red', label: t('tracker.legend.unavailable', 'Niet beschikbaar') },
        { variant: 'scheduled', label: t('tracker.legend.scheduled', 'Gepland') },
        { variant: 'tan', label: t('tracker.legend.reserved', 'Gereserveerd') },
    ];
    return (
        <div className={`map-legend ${inline ? 'map-legend-inline' : ''}`} aria-label={t('tracker.legend.title', 'Legenda')}>
            {items.map(item => (
                <span className="map-legend-item" key={item.variant}>
                    <LegendSwatch variant={item.variant} />
                    {item.label}
                </span>
            ))}
        </div>
    );
}

export default MapLegend;
